import { render, staticRenderFns } from "./mineNews.vue?vue&type=template&id=6e426a35&scoped=true"
import script from "./mineNews.vue?vue&type=script&lang=js"
export * from "./mineNews.vue?vue&type=script&lang=js"
import style0 from "./mineNews.vue?vue&type=style&index=0&id=6e426a35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e426a35",
  null
  
)

export default component.exports